import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconXBold = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.13248 4.00022L6.92248 1.21022C6.93917 1.1922 6.94844 1.16854 6.94844 1.14397C6.94844 1.11941 6.93917 1.09575 6.92248 1.07772C6.90446 1.06103 6.88079 1.05176 6.85623 1.05176C6.83166 1.05176 6.808 1.06103 6.78998 1.07772L3.99998 3.86772L1.20998 1.07772C1.19196 1.06103 1.1683 1.05176 1.14373 1.05176C1.11916 1.05176 1.0955 1.06103 1.07748 1.07772C1.06079 1.09575 1.05151 1.11941 1.05151 1.14397C1.05151 1.16854 1.06079 1.1922 1.07748 1.21022L3.86748 4.00022L1.07748 6.79022C1.06079 6.80825 1.05151 6.83191 1.05151 6.85647C1.05151 6.88104 1.06079 6.9047 1.07748 6.92272C1.09572 6.94006 1.11982 6.94987 1.14498 6.95022C1.15711 6.95026 1.16912 6.94784 1.18029 6.94311C1.19146 6.93838 1.20156 6.93145 1.20998 6.92272L3.99998 4.13272L6.78998 6.92272C6.80731 6.9399 6.83059 6.94974 6.85498 6.95022C6.88014 6.94987 6.90424 6.94006 6.92248 6.92272C6.93917 6.9047 6.94844 6.88104 6.94844 6.85647C6.94844 6.83191 6.93917 6.80825 6.92248 6.79022L4.13248 4.00022Z",
		fill: "#303651",
		stroke: "#303651",
		strokeWidth: .5
	})
});
export default SvgIconXBold;
